// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T17:28:03.464Z
// Property: Hunt Club (ID: 6767906449166895)
// Collections: 18 amenities, 4 floorplans (live), 30 photos, 41 POIs, 4 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166895",
  "property_external_id": "495807",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/3726-s-180th-st-seattle-wa/1zjqmm7/",
  "property_google_business_url": "https://www.google.com/maps/place/Hunt+Club+Apartments/data=!4m2!3m1!1s0x0:0x885fb3372b011196?sa=X&ved=2ahUKEwj6yqmVjbySAxWFS_EDHQUGDVUQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": "https://www.linkedin.com/company/hunt-club-llc",
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495807 p0505475",
  "property_status": null,
  "property_slug": "hunt-club",
  "property_name": "Hunt Club",
  "property_website_url": "https://www.seatacwashingtonapartments.com/",
  "property_domain": "https://www.seatacwashingtonapartments.com/",
  "property_address": "3726 South 180th Place",
  "property_full_address": "3726 S 180th Pl, SeaTac, WA 98188",
  "property_address_1": "3726 South 180th Place",
  "property_address_2": null,
  "property_address_city": "SeaTac",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98188",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": null,
  "property_address_latitude": "47.4410037",
  "property_address_longitude": "-122.2877039",
  "property_email": "huntclub@ctlmanagement.com",
  "property_phone": "(206) 639-2504",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Hunt Club, your serene retreat in SeaTac! Choose from our spacious one-, two-, or three-bedroom floor plans, all nestled in a vibrant community. Enjoy top-tier amenities like a refreshing pool, cozy coffee bar, and a 24-hour fitness facility. Your ideal living experience awaits—find your perfect home today!",
  "property_long_description": "Welcome to Hunt Club, your perfect retreat in the heart of SeaTac, WA. Our diverse floor plans include inviting one, two, and three-bedroom apartments, designed to cater to your unique lifestyle needs. Whether you’re a young professional, a growing family, or seeking a cozy nest, you'll find the ideal space here.\n\nAt Hunt Club, we pride ourselves on offering an array of outstanding amenities that enhance your living experience. Unwind at our stunning swimming pool, or grab a coffee at our community coffee bar while you catch up on work in our fully-equipped business center. Enjoy the outdoors with friends at our covered BBQ area or participate in our resident activity program, fostering a vibrant community spirit. \n\nWe also offer the convenience of online rent payments and service requests, ensuring your daily needs are met with ease. For families, our playground provides endless fun, while fitness enthusiasts can take advantage of our modern fitness facility. Plus, with 24-hour laundry rooms and package lockers, your lifestyle remains hassle-free.\n\nHunt Club is a smoke-free community that embraces flexibility with our lease terms, making it easier for you to settle into your new home. Some of our apartments even feature cozy wood-burning fireplaces, perfect for those chilly evenings.\n\nReady to find your new home? Explore our availability to discover your ideal floor plan or schedule a tour today to experience all that Hunt Club has to offer! Don’t miss out on the opportunity to elevate your living experience in SeaTac!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d2bf3-320b-724f-bf14-812d70a69db3.webp",
  "property_featured_image_media": {
    "alt_text": "Leasing office entrance with landscaping and outdoor pool visible in background.",
    "public_id": "019d2bf3-320b-724f-bf14-812d70a69db3",
    "storage_key": "property/6767906449166895/019d2bf3-320b-724f-bf14-812d70a69db3.webp",
    "width": 2560,
    "height": 1195
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Deposit: $400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "400",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Deposit and monthly pet rent are per pet.  Small caged animals are allowed without a deposit and pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Max 2 Allowed | Max weight 25 lb each\nRent $30 | Deposit $400",
  "property_online_leasing_url": "https://seatacwashingtonapartments.securecafe.com/onlineleasing/hunt-club-6/guestlogin",
  "property_resident_portal_url": "https://seatacwashingtonapartments.securecafenet.com/residentservices/hunt-club-6/userlogin",
  "property_apply_now_url": "https://seatacwashingtonapartments.securecafe.com/onlineleasing/hunt-club-6/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d73d6-d799-7777-88c6-f02f46d37cf2.webp",
  "property_primary_logo_media": {
    "alt_text": "Hunt Club Apartments logo",
    "public_id": "019d73d6-d799-7777-88c6-f02f46d37cf2",
    "storage_key": "property/6767906449166895/019d73d6-d799-7777-88c6-f02f46d37cf2.webp",
    "width": 481,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d73d6-d6e9-71e9-a30f-02e2839bf02e.webp",
  "property_secondary_logo_media": {
    "alt_text": "Hunt Club Apartments logo.",
    "public_id": "019d73d6-d6e9-71e9-a30f-02e2839bf02e",
    "storage_key": "property/6767906449166895/019d73d6-d6e9-71e9-a30f-02e2839bf02e.webp",
    "width": 477,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019de0b2-a420-70a5-83f0-8e0ebdb2c00e.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Placeholder image",
    "public_id": "019de0b2-a420-70a5-83f0-8e0ebdb2c00e",
    "storage_key": "property/6767906449166895/019de0b2-a420-70a5-83f0-8e0ebdb2c00e.webp",
    "width": 481,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019de0b2-98f6-72b9-8701-b519eaad401d.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Black horizontal bar",
    "public_id": "019de0b2-98f6-72b9-8701-b519eaad401d",
    "storage_key": "property/6767906449166895/019de0b2-98f6-72b9-8701-b519eaad401d.webp",
    "width": 481,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "580 - 1013",
  "property_sqft_min": "580",
  "property_sqft_max": "1013",
  "property_price_range": "1470 - 2700",
  "property_price_min": "1470",
  "property_price_max": "2700",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/p/Hunt-Club-Apartments-100063727614910/",
  "property_instagram_url": "https://www.instagram.com/onthehuntco_/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJpcqfUKVckFQRlhEBKzezX4g",
  "property_youtube_url": "https://www.youtube.com/watch?t=167&v=79L2te7Y8tU",
  "property_yelp_url": "https://fr.yelp.ca/search?find_desc=5+Stars&find_loc=Seatac%2C+WA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Hunt Club",
  "property_home_romance_title": "Experience the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "Welcome to Hunt Club in SeaTac, WA, where your ideal living experience awaits! Choose from spacious one, two, or three-bedroom floor plans, and enjoy amenities like a refreshing swimming pool, a cozy coffee bar, and a vibrant resident activity program—perfect for making lasting memories. ",
  "property_home_floorplans_blurb": "At Hunt Club in SeaTac, WA, find your ideal space designed for modern living. Our diverse floor plans cater to every lifestyle, whether you seek cozy intimacy or expansive areas for entertaining. Browse our available apartment homes today and unlock a lifestyle that truly feels like home.",
  "property_home_gallery_blurb": "At Hunt Club in vibrant SeaTac, WA, every moment is a delight. Choose from spacious one, two, or three-bedroom floor plans, each with modern amenities like a fitness facility, 24-hour laundry, and a relaxing swimming pool. Picture yourself enjoying outdoor BBQs, cozying up by the fireplace, or working from our focused business center!",
  "property_home_neighborhood_blurb": "At Hunt Club in SeaTac, WA, life is vibrant and full of adventure. Choose from one, two, or three-bedroom floor plans that fit your lifestyle. With attractions like Gene Coulon Memorial Beach Park, The Museum of Flight, and accesso ShoWare Center nearby, your ideal living experience awaits!",
  "property_home_reviews_blurb": "At Hunt Club in SeaTac, WA, residents rave about the vibrant community and beautiful surroundings. One resident notes, \"The peaceful atmosphere and friendly neighbors make it feel like home!\" Curious about their experiences? Dive into our reviews and see what makes Hunt Club a cherished place to live!",
  "property_neighborhood_blurb": "At Hunt Club in SeaTac, WA, immerse yourself in a vibrant community surrounded by local gems. Unwind at Gene Coulon Memorial Beach Park or explore the captivating exhibits at The Museum of Flight. With quick access to Highline College and premier shopping at Westfield Southcenter, everything you need is just outside your door!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Hunt Club in SeaTac, WA, where modern living meets comfort. Choose from one, two, or three-bedroom layouts tailored to suit your lifestyle. Enjoy vibrant community amenities, including a business center, coffee bar, fitness facility, and a refreshing swimming pool. Experience seamless living with flexible lease terms and online services.",
  "property_applynow_blurb": "At Hunt Club in SeaTac, WA, your ideal living space awaits with one, two, and three-bedroom floor plans. Enjoy top-tier amenities like a cozy coffee bar, a shimmering swimming pool, and a vibrant resident activity program, all while embracing a smoke-free lifestyle. Lease online today to elevate your home experience!",
  "property_contactus_blurb": "At Hunt Club in SeaTac, WA, find the perfect retreat among our thoughtfully designed one, two, and three-bedroom floor plans. Each space blends comfort with modern living, tailored for your lifestyle. Have questions? Contact our leasing team today and let us help you find your ideal home!",
  "property_faqs_blurb": "At Hunt Club in SeaTac, WA, your perfect home awaits! Choose from one, two, or three-bedroom floor plans designed to suit your lifestyle. Have questions? Our FAQs page offers insights to help make your experience seamless. Uncover essential information and find your ideal living space today!",
  "property_floorplans_blurb": "At Hunt Club in SeaTac, WA, our thoughtfully designed floor plans cater to your lifestyle. Choose from cozy one-bedroom nooks, spacious two-bedroom retreats, or expansive three-bedroom sanctuaries. Each home invites comfort and style. Browse our available apartment homes today and uncover the ideal layout that suits your needs!",
  "property_gallery_blurb": "At Hunt Club in SeaTac, WA, our vibrant community offers stunning one, two, and three-bedroom apartments tailored for your lifestyle. Enjoy amenities like a smoke-free environment, a sparkling swimming pool, and a cozy coffee bar. Picture yourself living here and embracing a life filled with comfort and style!",
  "property_interactivemap_blurb": "Welcome to Hunt Club, your oasis in SeaTac, WA. With spacious one, two, and three-bedroom floor plans, our amenities enhance your lifestyle, featuring a state-of-the-art fitness center, a cozy coffee bar, and inviting cabanas. Dive into comfort—use our interactive community map to find your ideal apartment today!",
  "property_pets_blurb": "At Hunt Club in SeaTac, WA, your furry friends are family! Our pet-friendly community welcomes indoor adult cats and dogs up to 25 lbs. Enjoy quality moments together in lush green spaces. Bring along your small caged companions—no extra fees—because we believe every pet deserves a loving home.",
  "property_referafriend_blurb": "At Hunt Club in SeaTac, WA, we offer a variety of thoughtfully designed floor plans—one, two, and three bedrooms—that perfectly suit your lifestyle. Embrace the joy of community living! Great friends make great neighbors; refer a friend today and enhance your living experience together!",
  "property_residentaccess_blurb": "At Hunt Club in SeaTac, WA, your comfort is our priority. Choose from spacious one, two, or three-bedroom floor plans tailored to your lifestyle. Access your resident portal effortlessly to pay rent, schedule maintenance, and enjoy a seamless living experience in our vibrant community. Your ideal home awaits!",
  "property_reviews_blurb": "At Hunt Club in SeaTac, WA, our residents cherish the sense of community and comfort we provide. One resident raves, “The management is amazing and the amenities are top-notch!” Join us and see what our residents have to say about living at our welcoming community!",
  "property_created_at": "1762784914730",
  "property_scheduletour_blurb": "At Hunt Club in SeaTac, WA, experience spacious living with one, two, and three-bedroom floor plans tailored to your lifestyle. Schedule a tour to envision your new home, and hear firsthand what our residents love about their vibrant community. Your next chapter starts here!",
  "property_thankyou_blurb": "Thank you for reaching out to Hunt Club in SeaTac, WA! Our diverse range of stylish one, two, and three-bedroom floor plans are designed for comfort and modern living. A team member will connect with you shortly to help you find your perfect home in our vibrant community.",
  "property_virtualtours_blurb": "At Hunt Club in SeaTac, WA, your dream home awaits! Choose from stylish one, two, or three-bedroom floor plans designed with modern living in mind. Immerse yourself in our vibrant community from the comfort of your screen—take a virtual tour of our exceptional apartments for rent today!",
  "property_copyright": "2025 All Rights Reserved. Hunt Club",
  "property_seo_title_home": "Hunt Club |  Apartments in SeaTac, WA",
  "property_seo_description_home": "Welcome to Hunt Club in SeaTac, WA! Enjoy diverse floor plans, modern amenities, and a vibrant community. Your dream home awaits—make it yours today!",
  "property_seo_title_floorplans": "Floor Plans | SeaTac, WA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Hunt Club in SeaTac, WA! Choose from cozy one to spacious three-bedroom apartments. Browse our floor plans today!",
  "property_seo_title_amenities": "Amenities | SeaTac, WA Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort at Hunt Club in SeaTac, WA! Enjoy business amenities, a 24-hour fitness facility, cabana rentals, and more. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in SeaTac, WA",
  "property_seo_description_gallery": "Unwind at Hunt Club in SeaTac, WA! Enjoy modern living with top amenities, including a fitness center and relaxing cabana. Your dream home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Hunt Club Apartments",
  "property_seo_description_virtualtours": "Experience Hunt Club in SeaTac, WA! Immerse yourself in our virtual tour and envision life in our stunning one, two, and three-bedroom apartments.",
  "property_seo_title_interactivemap": "Interactive Map | Hunt Club Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Hunt Club in SeaTac, WA! Browse our interactive map for flexible living options, top amenities, and a welcoming community.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in SeaTac, WA",
  "property_seo_description_neighborhood": "Uncover the charm of SeaTac at Hunt Club. Dive into a vibrant neighborhood filled with local favorites, parks, and easy access to everything you love!",
  "property_seo_title_contact": "Contact Us | Hunt Club",
  "property_seo_description_contact": "Reach out to Hunt Club in SeaTac, WA! Our leasing team is ready to assist you in finding the perfect one, two, or three-bedroom apartment. Let's chat today!",
  "property_seo_title_faqs": "FAQs | Apartments in SeaTac, WA",
  "property_seo_description_faqs": "Uncover the answers to your questions at Hunt Club in SeaTac, WA. From floor plans to amenities, explore our FAQs for a seamless living experience!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in SeaTac, WA",
  "property_seo_description_reviews": "Join the Hunt Club community in SeaTac, WA! Discover vibrant living with 24/7 amenities and flexible leases. See why residents love calling us home!",
  "property_seo_title_applynow": "Apply Now | Apartments in SeaTac, WA",
  "property_seo_description_applynow": "Discover effortless living at Hunt Club in SeaTac, WA. Choose from 1-3 bedroom apartments with amazing amenities—apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Hunt Club",
  "property_seo_description_residentaccess": "Login to Hunt Club's resident portal in SeaTac, WA! Manage rent, request maintenance, and enjoy hassle-free living at your fingertips. Join us today!",
  "property_seo_title_referafriend": "Refer A Friend | Hunt Club",
  "property_seo_description_referafriend": "Refer a friend to Hunt Club in SeaTac, WA—where great friends become great neighbors! Share the joy of our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Hunt Club",
  "property_seo_description_scheduletour": "Experience the charm of Hunt Club in SeaTac, WA. Schedule a tour today and envision your new life in our vibrant apartment community!",
  "property_seo_title_privacy": "Privacy Policy | Hunt Club",
  "property_seo_description_privacy": "At Hunt Club in SeaTac, WA, your privacy matters. Discover how we protect your information for a secure living experience. View our policy.",
  "property_seo_title_accessibility": "Website Accessibility | Hunt Club",
  "property_seo_description_accessibility": "At Hunt Club in SeaTac, WA, we prioritize digital inclusion, ensuring everyone can navigate our community online. Join us in making connections accessible!",
  "property_seo_title_sitemap": "Sitemap | Hunt Club",
  "property_seo_description_sitemap": "Unlock the layout of Hunt Club in SeaTac, WA! Check our sitemap for seamless navigation through our apartment offerings and community amenities.",
  "property_seo_title_thankyou": "Thank You | Hunt Club",
  "property_seo_description_thankyou": "Thank you for reaching out to Hunt Club in SeaTac! Our team will connect soon to help you find your perfect apartment home. Exciting living awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in SeaTac, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293661381",
  "amenities": [
    {
      "id": "ec_32f76b3c066513e616c95b6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "yardi",
      "external_id": "87310429",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_429012f002fdb066b1266627",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "yardi",
      "external_id": "80428977",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-4f76-764c-ae8e-fb3364dc692d.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with cardio machines, weight machines, free weights, and a water cooler.",
        "public_id": "019d571d-4f76-764c-ae8e-fb3364dc692d",
        "storage_key": "property/6767906449166895/019d571d-4f76-764c-ae8e-fb3364dc692d.webp",
        "width": 1920,
        "height": 1281
      },
      "amenity_image_alt_text": "Hunt Club fitness center and equipment",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b5801a1b5f5c07c8fb595574",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "yardi",
      "external_id": "80428984",
      "title": "Seasonal Outdoor Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d42a6-fb61-77b6-89f8-6cc1bb0013f4.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d42a6-fb61-77b6-89f8-6cc1bb0013f4",
        "storage_key": "property/6767906449166895/019d42a6-fb61-77b6-89f8-6cc1bb0013f4.webp",
        "width": 971,
        "height": 664
      },
      "amenity_image_alt_text": "Hunt Club Apartments Pool",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ee28a13eed69d06ebbb929d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "yardi",
      "external_id": "80428983",
      "title": "Outdoor Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d42a7-0072-7427-ab6a-7570eaf4be61.webp",
      "amenity_image_media": {
        "alt_text": "Playground with green and blue climbing structures, slides, and monkey bars.",
        "public_id": "019d42a7-0072-7427-ab6a-7570eaf4be61",
        "storage_key": "property/6767906449166895/019d42a7-0072-7427-ab6a-7570eaf4be61.webp",
        "width": 1029,
        "height": 683
      },
      "amenity_image_alt_text": "Hunt Club Apartments Playground",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e92e65cd00fb91100afc7ace",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "yardi",
      "external_id": "80428974",
      "title": "Covered BBQ Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-5126-7474-ac93-7b6bc8fdf7ab.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor covered picnic area with grill and seating, apartment buildings in background.",
        "public_id": "019d571d-5126-7474-ac93-7b6bc8fdf7ab",
        "storage_key": "property/6767906449166895/019d571d-5126-7474-ac93-7b6bc8fdf7ab.webp",
        "width": 1920,
        "height": 1281
      },
      "amenity_image_alt_text": "Hunt Club BBQ and picnic area",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_615851b98291ab9b3b69e785",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "yardi",
      "external_id": "80428978",
      "title": "Laundry Rooms Open 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d42a6-fa33-7610-b523-49def08d3699.webp",
      "amenity_image_media": {
        "alt_text": "Laundry room with multiple washing machines and dryers, and a window overlooking the property.",
        "public_id": "019d42a6-fa33-7610-b523-49def08d3699",
        "storage_key": "property/6767906449166895/019d42a6-fa33-7610-b523-49def08d3699.webp",
        "width": 1029,
        "height": 683
      },
      "amenity_image_alt_text": "Hunt Club Apartments Laundry Room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40aa46f189f81eea2ccb0d19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "yardi",
      "external_id": "80654321",
      "title": "Cabana with Complimentary Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-4e58-728c-9d7c-68f9db7cdf3b.webp",
      "amenity_image_media": {
        "alt_text": "Community lounge area with leather seating and a view of the pool.",
        "public_id": "019d571d-4e58-728c-9d7c-68f9db7cdf3b",
        "storage_key": "property/6767906449166895/019d571d-4e58-728c-9d7c-68f9db7cdf3b.webp",
        "width": 1920,
        "height": 1281
      },
      "amenity_image_alt_text": "Hunt Club clubhouse lounge",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac91e2265be1ad4dea010986",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "yardi",
      "external_id": "86392910",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f5e2d8940fdbc580ae79e0aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "yardi",
      "external_id": "120559256",
      "title": "24-Hour Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-704e-72dd-95a8-7c83ef21328f.webp",
      "amenity_image_media": {
        "alt_text": "Mailboxes and Amazon Hub package locker with a bench in front.",
        "public_id": "019d571d-704e-72dd-95a8-7c83ef21328f",
        "storage_key": "property/6767906449166895/019d571d-704e-72dd-95a8-7c83ef21328f.webp",
        "width": 1920,
        "height": 1281
      },
      "amenity_image_alt_text": "Hunt Club mail station and Amazon Hub",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d246f3249c18b357391b3fc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "yardi",
      "external_id": "80428972",
      "title": "Cabana Rentals",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-241a-77d9-9d2b-db75417555e8.webp",
      "amenity_image_media": {
        "alt_text": "A dining area with a long table and chairs, a console table with a mirror, and decorative wall art.",
        "public_id": "019d571d-241a-77d9-9d2b-db75417555e8",
        "storage_key": "property/6767906449166895/019d571d-241a-77d9-9d2b-db75417555e8.webp",
        "width": 1920,
        "height": 1275
      },
      "amenity_image_alt_text": "Hunt Club clubhouse dining seating,A kitchen with a stainless steel refrigerator and a stainless steel oven.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2717676883af4c2fe3eb3f01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "yardi",
      "external_id": "81384758",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_092bcded3cea03db68d8cca9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "yardi",
      "external_id": "82390169",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b128c4f20e210f11e962ea5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "yardi",
      "external_id": "82390171",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3bb1e09218acf4bcf2c0efd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "yardi",
      "external_id": "86392958",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac2019ebe65669c5a51ac3f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "yardi",
      "external_id": "80428989",
      "title": "Wood Burning Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d42a6-d5fe-7631-952e-3f325955beef.webp",
      "amenity_image_media": {
        "alt_text": "Living room with fireplace and sliding glass door to balcony.",
        "public_id": "019d42a6-d5fe-7631-952e-3f325955beef",
        "storage_key": "property/6767906449166895/019d42a6-d5fe-7631-952e-3f325955beef.webp",
        "width": 1117,
        "height": 728
      },
      "amenity_image_alt_text": "Hunt Club Apartments Vacant Apartment Living Room & Fireplace",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a771e86ead4242c237dec86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "yardi",
      "external_id": "127756382",
      "title": "Standard Kitchen Appliances Included",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f747ad991f34f95f6eac6a95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "yardi",
      "external_id": "87310430",
      "title": "Stackable Washer/Dryer in 2 Bedroom 1 Bath Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d1bfe-c8c0-77d9-821f-22c2cc03cc9a.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with white appliances including a stacked washer and dryer, dishwasher, stove, and refrigerator.",
        "public_id": "019d1bfe-c8c0-77d9-821f-22c2cc03cc9a",
        "storage_key": "property/6767906449166895/019d1bfe-c8c0-77d9-821f-22c2cc03cc9a.webp",
        "width": 1155,
        "height": 783
      },
      "amenity_image_alt_text": "Hunt Club Apartments Vacant Apartment Upgraded Kitchen",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4ee7674535c8b106e131023",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "yardi",
      "external_id": "87310431",
      "title": "Side By Side Washer/Dryer in 3 Bedroom 2 Bath Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_40dc84879dce4507e17c5f8f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d1bfe-c665-7041-bab9-f236c0b282d2.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, granite countertops, white appliances including a stove and refrigerator, and a sink.",
        "public_id": "019d1bfe-c665-7041-bab9-f236c0b282d2",
        "storage_key": "property/6767906449166895/019d1bfe-c665-7041-bab9-f236c0b282d2.webp",
        "width": 1165,
        "height": 769
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring white cabinetry, durable granite countertops, and a full suite of modern appliances. Includes a sink and ample storage space.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, granite countertops, white appliances including a stove and refrigerator, and a sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Hunt Club Apartments_Sea Tac_WA_UpgradedKitchen02.jpg"
    },
    {
      "id": "ec_8c715b926f6271ea816f911d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d1bfe-c8c0-77d9-821f-22c2cc03cc9a.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances including a stacked washer and dryer, dishwasher, stove, and refrigerator.",
        "public_id": "019d1bfe-c8c0-77d9-821f-22c2cc03cc9a",
        "storage_key": "property/6767906449166895/019d1bfe-c8c0-77d9-821f-22c2cc03cc9a.webp",
        "width": 1155,
        "height": 783
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring a stacked washer and dryer, dishwasher, stove, and refrigerator for your convenience.",
      "link": "false",
      "alt_text": "Kitchen with white appliances including a stacked washer and dryer, dishwasher, stove, and refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Hunt Club Apartments_Sea Tac_WA_UpgradedKitchen01.jpg"
    },
    {
      "id": "ec_83b777a799d4df896e2b1faa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d1bfe-c9e7-7178-850b-1f3a41f867bf.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, refrigerator, and oven, opening into a living area with a fireplace and balcony access.",
        "public_id": "019d1bfe-c9e7-7178-850b-1f3a41f867bf",
        "storage_key": "property/6767906449166895/019d1bfe-c9e7-7178-850b-1f3a41f867bf.webp",
        "width": 1159,
        "height": 763
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring white cabinetry, a refrigerator, and an oven. The adjoining living area includes a cozy fireplace and access to a private balcony.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, refrigerator, and oven, opening into a living area with a fireplace and balcony access.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Hunt Club Apartments_Sea Tac_WA_UpgradedKitchen03.jpg"
    },
    {
      "id": "ec_fb70b8bb3683f8356a7c97ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d1bfe-ca3c-76f4-acac-dda576b1c285.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with fireplace and balcony view.",
        "public_id": "019d1bfe-ca3c-76f4-acac-dda576b1c285",
        "storage_key": "property/6767906449166895/019d1bfe-ca3c-76f4-acac-dda576b1c285.webp",
        "width": 1182,
        "height": 783
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a cozy fireplace, adjacent to a modern kitchen with ample cabinet space. Access to a private balcony.",
      "link": "false",
      "alt_text": "Living room and kitchen area with fireplace and balcony view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Hunt Club Apartments_Sea Tac_WA_UpgradedKitchen04.jpg"
    },
    {
      "id": "ec_9c6851080b5e85e303c36361",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d1bfe-c917-7300-a34e-8808576fcf41.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, refrigerator, stove, and sink.",
        "public_id": "019d1bfe-c917-7300-a34e-8808576fcf41",
        "storage_key": "property/6767906449166895/019d1bfe-c917-7300-a34e-8808576fcf41.webp",
        "width": 1166,
        "height": 782
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring white cabinetry, a refrigerator, a stove, and a deep sink, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, refrigerator, stove, and sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Hunt Club Apartments_Sea Tac_WA_UpgradedKitchen05.jpg"
    },
    {
      "id": "ec_678b28e55478953c68aa8cf6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d1bfe-c667-75eb-8681-f423028f09f8.webp",
      "image_media": {
        "alt_text": "Empty apartment bedroom with a closet and window.",
        "public_id": "019d1bfe-c667-75eb-8681-f423028f09f8",
        "storage_key": "property/6767906449166895/019d1bfe-c667-75eb-8681-f423028f09f8.webp",
        "width": 1163,
        "height": 758
      },
      "title": "Apartment",
      "description": "Spacious apartment bedroom featuring a large window for natural light and ample closet space. Perfect for creating your personal retreat.",
      "link": "false",
      "alt_text": "Empty apartment bedroom with a closet and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Hunt Club Apartments_Seatac_WA_Bedroom.jpg"
    },
    {
      "id": "ec_a6008aec0fc0f729f5851cea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d1bfe-c9cc-716f-ba44-de55824930f6.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet doors and access to bathroom",
        "public_id": "019d1bfe-c9cc-716f-ba44-de55824930f6",
        "storage_key": "property/6767906449166895/019d1bfe-c9cc-716f-ba44-de55824930f6.webp",
        "width": 1183,
        "height": 742
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, mirrored closet doors, and convenient access to a bathroom.",
      "link": "false",
      "alt_text": "Bedroom with mirrored closet doors and access to bathroom",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Hunt Club Apartments_Seatac_WA_Bedroom02.jpg"
    },
    {
      "id": "ec_55150207b42cad8f4babee1d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d1bfe-c65f-741e-af2f-4189c7b029b4.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink and toilet next to bathtub",
        "public_id": "019d1bfe-c65f-741e-af2f-4189c7b029b4",
        "storage_key": "property/6767906449166895/019d1bfe-c65f-741e-af2f-4189c7b029b4.webp",
        "width": 1174,
        "height": 780
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a vanity with a sink, toilet, and a bathtub with shower.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink and toilet next to bathtub",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Hunt Club Apartments_Seatac_WA_UpgradedBathroom02.jpg"
    },
    {
      "id": "ec_69b177e24e524d68ba9698c4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d1bfe-c978-7058-b811-55f3e4dc8402.webp",
      "image_media": {
        "alt_text": "Kitchenette and living area with fireplace",
        "public_id": "019d1bfe-c978-7058-b811-55f3e4dc8402",
        "storage_key": "property/6767906449166895/019d1bfe-c978-7058-b811-55f3e4dc8402.webp",
        "width": 1010,
        "height": 665
      },
      "title": "Apartment",
      "description": "Compact kitchen area with cabinets, sink, and dishwasher, opening to a living space with a fireplace and plush carpeting.",
      "link": "false",
      "alt_text": "Kitchenette and living area with fireplace",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/HuntClub_SeaTac_WA_NonUpgradedKitchen02.jpg"
    },
    {
      "id": "ec_61eb2ae1ab647625f11ba9ed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d1bfe-c651-70db-aa1e-81f5eaffe0aa.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, stove, and cabinets.",
        "public_id": "019d1bfe-c651-70db-aa1e-81f5eaffe0aa",
        "storage_key": "property/6767906449166895/019d1bfe-c651-70db-aa1e-81f5eaffe0aa.webp",
        "width": 683,
        "height": 1029
      },
      "title": "Apartment",
      "description": "A compact kitchen featuring a white refrigerator, a white electric stove with a black cooktop, and overhead cabinetry.",
      "link": "false",
      "alt_text": "Kitchen with white refrigerator, stove, and cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/HuntClub_SeaTac_WA_NonUpgradedKitchen03.jpg"
    },
    {
      "id": "ec_7970211ffb11bb48e052dbd2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d42a6-d5fe-7631-952e-3f325955beef.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and sliding glass door to balcony.",
        "public_id": "019d42a6-d5fe-7631-952e-3f325955beef",
        "storage_key": "property/6767906449166895/019d42a6-d5fe-7631-952e-3f325955beef.webp",
        "width": 1117,
        "height": 728
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a white brick fireplace, plush carpeting, and a sliding glass door that leads to a private balcony with scenic views.",
      "link": "false",
      "alt_text": "Living room with fireplace and sliding glass door to balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Hunt Club Apartments_Seatac_WA_LivingRoom.jpg"
    },
    {
      "id": "ec_9d78bdb5e6fdce2ded616f24",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d1bfe-dbb7-71fa-86b4-570d25bdfbaa.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub.",
        "public_id": "019d1bfe-dbb7-71fa-86b4-570d25bdfbaa",
        "storage_key": "property/6767906449166895/019d1bfe-dbb7-71fa-86b4-570d25bdfbaa.webp",
        "width": 683,
        "height": 1029
      },
      "title": "Apartment",
      "description": "A clean and functional apartment bathroom featuring a vanity with sink, toilet, and a bathtub with shower.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and bathtub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/HuntClub_SeaTac_WA_NonUpgradedBathroom.jpg"
    },
    {
      "id": "ec_2e38ef42fe0c30737feff225",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-2552-7312-8db9-ca6a72c7d95c.webp",
      "image_media": {
        "alt_text": "The Hunt Club Apartments monument sign and entrance",
        "public_id": "019d571d-2552-7312-8db9-ca6a72c7d95c",
        "storage_key": "property/6767906449166895/019d571d-2552-7312-8db9-ca6a72c7d95c.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Welcome to The Hunt Club Apartments, located at 3726 S 180th. Experience comfortable living in our community.",
      "link": "false",
      "alt_text": "The Hunt Club Apartments monument sign and entrance",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/HuntClub_SeaTac_WA_EntrySign.jpg"
    },
    {
      "id": "ec_a8c2c2b2b6b3e1ee87d7c641",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-22fe-74b9-9a8f-bf19bbaaf806.webp",
      "image_media": {
        "alt_text": "Leasing office building with a pool and landscaping.",
        "public_id": "019d571d-22fe-74b9-9a8f-bf19bbaaf806",
        "storage_key": "property/6767906449166895/019d571d-22fe-74b9-9a8f-bf19bbaaf806.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Visit our leasing office to learn more about our community amenities, including the swimming pool and beautifully maintained grounds.",
      "link": "false",
      "alt_text": "Leasing office building with a pool and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/HuntClub_SeaTac_WA_ClubhouseExteriorEntry.jpg"
    },
    {
      "id": "ec_cd24ebcd2b8ca577d5d908c5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-223d-750b-b243-2e08cf60dc45.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator, grey and white cabinets, oven, microwave, and sink in a kitchen.",
        "public_id": "019d571d-223d-750b-b243-2e08cf60dc45",
        "storage_key": "property/6767906449166895/019d571d-223d-750b-b243-2e08cf60dc45.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Modern kitchen with stainless steel appliances, including a refrigerator, oven, and microwave, ample cabinet space, and a sink. Perfect for any home chef.",
      "link": "false",
      "alt_text": "Stainless steel refrigerator, grey and white cabinets, oven, microwave, and sink in a kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/HuntClub_SeaTac_WA_ClubhouseKitchen.jpg"
    },
    {
      "id": "ec_176a351e2952bf6fe6a03c30",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-2283-76ab-83d6-99517b3adaaa.webp",
      "image_media": {
        "alt_text": "Kitchen with view of outdoor pool area.",
        "public_id": "019d571d-2283-76ab-83d6-99517b3adaaa",
        "storage_key": "property/6767906449166895/019d571d-2283-76ab-83d6-99517b3adaaa.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Modern kitchen with stainless steel appliances and a sliding glass door leading to an outdoor patio and pool area.",
      "link": "false",
      "alt_text": "Kitchen with view of outdoor pool area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/HuntClub_SeaTac_WA_ClubhouseKitchenSlidingGlassDoor.jpg"
    },
    {
      "id": "ec_1891eb77898a99feae824743",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-241a-77d9-9d2b-db75417555e8.webp",
      "image_media": {
        "alt_text": "A dining area with a long table and chairs, a console table with a mirror, and decorative wall art.",
        "public_id": "019d571d-241a-77d9-9d2b-db75417555e8",
        "storage_key": "property/6767906449166895/019d571d-241a-77d9-9d2b-db75417555e8.webp",
        "width": 1920,
        "height": 1275
      },
      "title": "Community",
      "description": "Enjoy a meal with friends and family in this communal dining area, perfect for gatherings and events.",
      "link": "false",
      "alt_text": "A dining area with a long table and chairs, a console table with a mirror, and decorative wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/HuntClub_SeaTac_WA_ClubhouseSeating.jpg"
    },
    {
      "id": "ec_f2f79081943af7db639f1160",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-5ad3-7674-8322-97b90d8c03bc.webp",
      "image_media": {
        "alt_text": "Dining area with a view of the pool.",
        "public_id": "019d571d-5ad3-7674-8322-97b90d8c03bc",
        "storage_key": "property/6767906449166895/019d571d-5ad3-7674-8322-97b90d8c03bc.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy meals and gatherings in our spacious dining area, with large glass doors opening to the sparkling pool and outdoor seating.",
      "link": "false",
      "alt_text": "Dining area with a view of the pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/HuntClub_SeaTac_WA_ClubhouseSeatingGreatRoom.jpg"
    },
    {
      "id": "ec_268b35e12be64abbac2be628",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-4e58-728c-9d7c-68f9db7cdf3b.webp",
      "image_media": {
        "alt_text": "Community lounge area with leather seating and a view of the pool.",
        "public_id": "019d571d-4e58-728c-9d7c-68f9db7cdf3b",
        "storage_key": "property/6767906449166895/019d571d-4e58-728c-9d7c-68f9db7cdf3b.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable community lounge, featuring plush seating and a direct view of the sparkling outdoor pool.",
      "link": "false",
      "alt_text": "Community lounge area with leather seating and a view of the pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/HuntClub_SeaTac_WA_CloubhouseLounge.jpg"
    },
    {
      "id": "ec_0d635a1b62df21b362fe5b02",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-6243-70d2-a9a9-5ff922b2f84c.webp",
      "image_media": {
        "alt_text": "Lobby seating area with leather sofas and a large coffee table.",
        "public_id": "019d571d-6243-70d2-a9a9-5ff922b2f84c",
        "storage_key": "property/6767906449166895/019d571d-6243-70d2-a9a9-5ff922b2f84c.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Relax in the comfortable and inviting lobby seating area, perfect for unwinding or meeting guests.",
      "link": "false",
      "alt_text": "Lobby seating area with leather sofas and a large coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/HuntClub_SeaTac_WA_ClubhouseLoungeSeating.jpg"
    },
    {
      "id": "ec_fa64a4212e1311fb580dac10",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-4f76-764c-ae8e-fb3364dc692d.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight machines, free weights, and a water cooler.",
        "public_id": "019d571d-4f76-764c-ae8e-fb3364dc692d",
        "storage_key": "property/6767906449166895/019d571d-4f76-764c-ae8e-fb3364dc692d.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Stay active and energized in our fully equipped fitness center, featuring a variety of cardio machines, weight training equipment, and free weights.",
      "link": "false",
      "alt_text": "Fitness center with cardio machines, weight machines, free weights, and a water cooler.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/HuntClub_SeaTac_WA_FitnessCenter.jpg"
    },
    {
      "id": "ec_1738f7b4e75cf5e2c4850be5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d42a6-fa33-7610-b523-49def08d3699.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washing machines and dryers, and a window overlooking the property.",
        "public_id": "019d42a6-fa33-7610-b523-49def08d3699",
        "storage_key": "property/6767906449166895/019d42a6-fa33-7610-b523-49def08d3699.webp",
        "width": 1029,
        "height": 683
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with modern washers and dryers, making chores a breeze. Enjoy the ease of doing laundry without leaving the property.",
      "link": "false",
      "alt_text": "Laundry room with multiple washing machines and dryers, and a window overlooking the property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Hunt Club Apartments_Seatac_WA_LaundryRoom.jpg"
    },
    {
      "id": "ec_a9b0aed06d6f86ecc18c01c5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d42a6-fb61-77b6-89f8-6cc1bb0013f4.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d42a6-fb61-77b6-89f8-6cc1bb0013f4",
        "storage_key": "property/6767906449166895/019d42a6-fb61-77b6-89f8-6cc1bb0013f4.webp",
        "width": 971,
        "height": 664
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Hunt Club Apartments_Seatac_WA_Pool01.jpg"
    },
    {
      "id": "ec_1bff8ad578e5c4fe6ee5305f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d42a7-0072-7427-ab6a-7570eaf4be61.webp",
      "image_media": {
        "alt_text": "Playground with green and blue climbing structures, slides, and monkey bars.",
        "public_id": "019d42a7-0072-7427-ab6a-7570eaf4be61",
        "storage_key": "property/6767906449166895/019d42a7-0072-7427-ab6a-7570eaf4be61.webp",
        "width": 1029,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring climbing structures and slides for children.",
      "link": "false",
      "alt_text": "Playground with green and blue climbing structures, slides, and monkey bars.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Hunt Club Apartments_Seatac_WA_Playground01.jpg"
    },
    {
      "id": "ec_a66046f3f74f5ec945f1b7c4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-5126-7474-ac93-7b6bc8fdf7ab.webp",
      "image_media": {
        "alt_text": "Outdoor covered picnic area with grill and seating, apartment buildings in background.",
        "public_id": "019d571d-5126-7474-ac93-7b6bc8fdf7ab",
        "storage_key": "property/6767906449166895/019d571d-5126-7474-ac93-7b6bc8fdf7ab.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings at our community picnic area, complete with a grill and ample seating, set against a backdrop of attractive apartment buildings.",
      "link": "false",
      "alt_text": "Outdoor covered picnic area with grill and seating, apartment buildings in background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/HuntClub_SeaTac_WA_BBQPicnicArea.jpg"
    },
    {
      "id": "ec_d44427ff79983e40b48d05ad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-704e-72dd-95a8-7c83ef21328f.webp",
      "image_media": {
        "alt_text": "Mailboxes and Amazon Hub package locker with a bench in front.",
        "public_id": "019d571d-704e-72dd-95a8-7c83ef21328f",
        "storage_key": "property/6767906449166895/019d571d-704e-72dd-95a8-7c83ef21328f.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Convenient mail and package delivery area featuring secure mailboxes and a modern Amazon Hub locker, with a relaxing bench for visitors.",
      "link": "false",
      "alt_text": "Mailboxes and Amazon Hub package locker with a bench in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/HuntClub_SeaTac_WA_MailStationAmazonHub.jpg"
    },
    {
      "id": "ec_928138d5dc5dccd633e89524",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-7433-764f-b482-634ab830f498.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with manicured lawn and trees.",
        "public_id": "019d571d-7433-764f-b482-634ab830f498",
        "storage_key": "property/6767906449166895/019d571d-7433-764f-b482-634ab830f498.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Beautifully maintained apartment complex featuring a light blue exterior, multiple levels with balconies, and lush green landscaping.",
      "link": "false",
      "alt_text": "Exterior of apartment building with manicured lawn and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/HuntClub_SeaTac_WA_BuildingExteriorGreenSpace.jpg"
    },
    {
      "id": "ec_80cdeb5e5ea34e379ec4ddd9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-7c1a-74b6-a3f4-b5955ee54043.webp",
      "image_media": {
        "alt_text": "Exterior building view with balconies and siding",
        "public_id": "019d571d-7c1a-74b6-a3f4-b5955ee54043",
        "storage_key": "property/6767906449166895/019d571d-7c1a-74b6-a3f4-b5955ee54043.webp",
        "width": 1920,
        "height": 1312
      },
      "title": "Community",
      "description": "Exterior view of the apartment building, showcasing the balconies and siding. This image represents the community's architecture.",
      "link": "false",
      "alt_text": "Exterior building view with balconies and siding",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/HuntClub_SeaTac_WA_BuildingExteriorDecks.jpg"
    },
    {
      "id": "ec_d0e7e91e3345d8740d72776b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-7ed5-7631-bb34-90b75aeb2a76.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and green lawn.",
        "public_id": "019d571d-7ed5-7631-bb34-90b75aeb2a76",
        "storage_key": "property/6767906449166895/019d571d-7ed5-7631-bb34-90b75aeb2a76.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Exterior view of the apartment buildings, showcasing the architecture and surrounding green spaces.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and green lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/HuntClub_SeaTac_WA_BuildingExteriorEntrances.jpg"
    },
    {
      "id": "ec_aad363e59e56b8aeb440f0e6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d571d-9d0f-70ab-9f7e-7c823af0a884.webp",
      "image_media": {
        "alt_text": "View of the apartment buildings' exterior with manicured lawns and a walking path.",
        "public_id": "019d571d-9d0f-70ab-9f7e-7c823af0a884",
        "storage_key": "property/6767906449166895/019d571d-9d0f-70ab-9f7e-7c823af0a884.webp",
        "width": 1920,
        "height": 1284
      },
      "title": "Community",
      "description": "Discover the beautifully maintained grounds and exteriors of our apartment community, featuring lush green lawns and inviting walkways.",
      "link": "false",
      "alt_text": "View of the apartment buildings' exterior with manicured lawns and a walking path.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/HuntClub_SeaTac_WA_BuildingExteriorWalkway.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_9a5d7fa5-7a38-4e61-a50c-355ad928c666",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Topgolf",
      "poi_type": "Restaurants",
      "poi_address": "780 Logan Ave N, Renton, WA 98057, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun and unique golfing experience with a variety of games, as well as tasty food and drinks, including chicken strips, tots, and donut holes. They also highlight the friendly and helpful staff, the clean and comfortable atmosphere, and the reasonable prices, especially during off-peak hours.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-d523-7698-bf51-ccedbaf32518.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-d523-7698-bf51-ccedbaf32518",
        "storage_key": "property/6767906449166895/019d08ad-d523-7698-bf51-ccedbaf32518.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://topgolf.com/us/renton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17862906076997390043&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf",
      "poi_latitude": "47.4949267",
      "poi_longitude": "-122.2063361",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 425-517-0695",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-7a24-73fd-8de3-5fbfb2458bdd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7a24-73fd-8de3-5fbfb2458bdd",
        "storage_key": "property/6767906449166895/019d08ad-7a24-73fd-8de3-5fbfb2458bdd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf5TFdg5pkFQR246Yb2_K5fc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_099a35ae-ad00-4b5e-87f8-43cb965aa7ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Feast Buffet",
      "poi_type": "Restaurants",
      "poi_address": "485 Renton Center Way SW, Renton, WA 98057, USA",
      "poi_short_description": "Spacious, contemporary restaurant offering all-you-can-eat Asian fare from dim sum to sushi.",
      "poi_long_description": "People say this buffet restaurant offers a huge variety of seafood, including lobster, crab legs, and oysters, as well as sushi, dim sum, and Mongolian stir fry. They also highlight the fresh food, the extensive dessert bar with options like creme brulee and cotton candy, and the good value, especially during lunch.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-d47b-7439-bda6-cad459e586a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-d47b-7439-bda6-cad459e586a9",
        "storage_key": "property/6767906449166895/019d08ad-d47b-7439-bda6-cad459e586a9.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "http://www.feastbuffetrenton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3396167711752454497&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "feast-buffet",
      "poi_latitude": "47.4765227",
      "poi_longitude": "-122.2177215",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 425-235-1888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-7a24-73fd-8de3-5fbfb2458bdd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7a24-73fd-8de3-5fbfb2458bdd",
        "storage_key": "property/6767906449166895/019d08ad-7a24-73fd-8de3-5fbfb2458bdd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvdObvbJCkFQRYQGoSIqcIS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_b7ef781c-a9df-4489-bc61-17eea0439c5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "17333 Southcenter Pkwy, Tukwila, WA 98188, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves good chicken sandwiches. They also highlight the friendly staff, fast service, and clean dining area with a play area.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-d47c-757f-8379-58df8985e3f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-d47c-757f-8379-58df8985e3f6",
        "storage_key": "property/6767906449166895/019d08ad-d47c-757f-8379-58df8985e3f6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/wa/southcenter-parkway?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=12040570452370729501&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "47.4479051",
      "poi_longitude": "-122.2631615",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-575-7547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-7a24-73fd-8de3-5fbfb2458bdd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7a24-73fd-8de3-5fbfb2458bdd",
        "storage_key": "property/6767906449166895/019d08ad-7a24-73fd-8de3-5fbfb2458bdd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgYi7o3ldkFQRHSqfYgizGKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_09901f6b-b73b-4ebf-b801-7af44666aa99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "13 Coins SeaTac",
      "poi_type": "Restaurants",
      "poi_address": "18000 International Blvd, SeaTac, WA 98188, USA",
      "poi_short_description": "Funky eatery serving Italian & American dishes, with high-backed booths & bar seating.",
      "poi_long_description": "People say this restaurant serves delicious chicken parmesan, prime rib, and French onion soup. They also highlight the comfortable booths, the convenient location near the airport, and the friendly staff.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ac-e951-7339-8676-11168c5758cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-e951-7339-8676-11168c5758cc",
        "storage_key": "property/6767906449166895/019d08ac-e951-7339-8676-11168c5758cc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.13coins.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2627747442472948407&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "13-coins-seatac",
      "poi_latitude": "47.44124900000001",
      "poi_longitude": "-122.295415",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-243-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-7a24-73fd-8de3-5fbfb2458bdd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7a24-73fd-8de3-5fbfb2458bdd",
        "storage_key": "property/6767906449166895/019d08ad-7a24-73fd-8de3-5fbfb2458bdd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzbIw6ahckFQRt5IKZGCidyQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_5c1ed6a5-ac52-4ed5-a549-467af9cbb716",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Din Tai Fung 鼎泰豐",
      "poi_type": "Restaurants",
      "poi_address": "181 Southcenter Mall, Tukwila, WA 98188, USA",
      "poi_short_description": "Casual, spacious dumpling house for lunch and dinner with Taiwanese options, cocktails, beer and wine.",
      "poi_long_description": "People say this Chinese restaurant serves delicious soup dumplings, green beans, and spicy wontons. They highlight the quick service, friendly staff, and clean atmosphere. They also like the extensive menu with vegetarian options and the tasty cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ac-f8bf-7687-945e-d9cca7d12e05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-f8bf-7687-945e-d9cca7d12e05",
        "storage_key": "property/6767906449166895/019d08ac-f8bf-7687-945e-d9cca7d12e05.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dtf.com/us/locations/tukwila.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=15945595886352380482&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "din-tai-fung-",
      "poi_latitude": "47.4584359",
      "poi_longitude": "-122.2608666",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-257-2888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-7a24-73fd-8de3-5fbfb2458bdd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7a24-73fd-8de3-5fbfb2458bdd",
        "storage_key": "property/6767906449166895/019d08ad-7a24-73fd-8de3-5fbfb2458bdd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJodnGp9NckFQRQrL2qfkiSt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_e4ba67ba-47c9-4d93-8bfa-2d61834d7372",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Westfield Southcenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2800 Southcenter Mall, Seattle, WA 98188, USA",
      "poi_short_description": "2-level indoor shopping mall with more than 200 stores & eateries plus a multiplex with IMAX.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, restaurants, and a movie theater. They also highlight the friendly staff, the fun and enjoyable shopping experience, and the convenient parking.\n\nSome reviews mention the mall can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-102f-77be-94e8-ebc3741b5023.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-102f-77be-94e8-ebc3741b5023",
        "storage_key": "property/6767906449166895/019d08ad-102f-77be-94e8-ebc3741b5023.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.westfield.com/en/united-states/southcenter",
      "poi_directions_map_url": "https://maps.google.com/?cid=7722388109786479024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westfield-southcenter",
      "poi_latitude": "47.4588849",
      "poi_longitude": "-122.257964",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-246-0423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-7e70-700b-a183-41f4398da1f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e70-700b-a183-41f4398da1f4",
        "storage_key": "property/6767906449166895/019d08ad-7e70-700b-a183-41f4398da1f4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1W80hNNckFQRsPmFJRJvK2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_01dd0c2a-0902-4a27-a586-ab286a521286",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "601 SW 41st St, Renton, WA 98057, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "People say this furniture store offers a wide selection of high-quality furniture and home decor. They also highlight the affordable prices, friendly and helpful staff, and easy returns.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-db9a-7783-9bb9-2448464df969.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-db9a-7783-9bb9-2448464df969",
        "storage_key": "property/6767906449166895/019d08ad-db9a-7783-9bb9-2448464df969.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/renton/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=renton",
      "poi_directions_map_url": "https://maps.google.com/?cid=14843228672508442262&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "47.4424006",
      "poi_longitude": "-122.2285737",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-7e70-700b-a183-41f4398da1f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e70-700b-a183-41f4398da1f4",
        "storage_key": "property/6767906449166895/019d08ad-7e70-700b-a183-41f4398da1f4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJu15VQR1dkFQRljbCuNW9_c0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_84fdfff7-da65-4f11-938c-51aa006a1fd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "21100 91st Pl S, Kent, WA 98031, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide variety of groceries, including fresh produce, meat, and bulk items, at affordable prices. They also highlight the friendly staff, convenient 24-hour service, and ample parking.\n\nOther reviews mention the checkout lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-dcde-750a-9852-a16422474a29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-dcde-750a-9852-a16422474a29",
        "storage_key": "property/6767906449166895/019d08ad-dcde-750a-9852-a16422474a29.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7441409303228944828&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "47.4146395",
      "poi_longitude": "-122.2190107",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 253-850-8818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-7a2c-727c-a66e-87c41e15e86d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7a2c-727c-a66e-87c41e15e86d",
        "storage_key": "property/6767906449166895/019d08ad-7a2c-727c-a66e-87c41e15e86d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnRR5LkFckFQRvJE_w1UyRWc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_0deb36fa-d9d0-4b01-9e41-90f969e99a1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Kent Station Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "417 Ramsay Way, Kent, WA 98032, USA",
      "poi_short_description": "Traditional shopping center offering a variety of shops, services, restaurants, cafes & a cinema.",
      "poi_long_description": "Traditional shopping center offering a variety of shops, services, restaurants, cafes & a cinema.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-dc44-716f-aae4-b5c52243a434.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-dc44-716f-aae4-b5c52243a434",
        "storage_key": "property/6767906449166895/019d08ad-dc44-716f-aae4-b5c52243a434.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://kentstation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11371983263310072599&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kent-station-shopping-center",
      "poi_latitude": "47.3844514",
      "poi_longitude": "-122.2351387",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 253-856-2301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-7e70-700b-a183-41f4398da1f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7e70-700b-a183-41f4398da1f4",
        "storage_key": "property/6767906449166895/019d08ad-7e70-700b-a183-41f4398da1f4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJsaj04_5bkFQRF8tI0YZm0Z0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1ed0aa00-281f-4aad-8663-a04bceaf8155",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "99 Ranch Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "18230 E Valley Hwy #100, Kent, WA 98032, USA",
      "poi_short_description": "Asian supermarket chain carrying imported specialty foods plus meat, seafood, produce & baked goods.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh seafood, vegetables, and other Asian foods, including canned goods, meat, and bakery items. They also highlight the reasonable prices, especially with discounts, and the friendly staff.\n\nOther reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-dcf4-7642-b650-2e5894f9942b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-dcf4-7642-b650-2e5894f9942b",
        "storage_key": "property/6767906449166895/019d08ad-dcf4-7642-b650-2e5894f9942b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.99ranch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3413166522718048566&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "99-ranch-market",
      "poi_latitude": "47.4387751",
      "poi_longitude": "-122.2209003",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 425-251-9099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-7a2c-727c-a66e-87c41e15e86d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-7a2c-727c-a66e-87c41e15e86d",
        "storage_key": "property/6767906449166895/019d08ad-7a2c-727c-a66e-87c41e15e86d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYS68mwJdkFQRNlHdYd4AXi8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_b3a3bc18-b8b2-47e5-94fc-96478be08abc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Highline College",
      "poi_type": "Education",
      "poi_address": "2400 S 240th St, Des Moines, WA 98198, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-230b-752f-896f-8b6f05f256c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-230b-752f-896f-8b6f05f256c9",
        "storage_key": "property/6767906449166895/019d08ad-230b-752f-896f-8b6f05f256c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.highline.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9102534943473461902&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "highline-college",
      "poi_latitude": "47.38833469999999",
      "poi_longitude": "-122.3017666",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-878-3710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8001-7703-8d73-fe364f06562d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8001-7703-8d73-fe364f06562d",
        "storage_key": "property/6767906449166895/019d08ad-8001-7703-8d73-fe364f06562d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf0oT_BNDkFQRjupQxU2zUn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a4a349f9-a3ea-473a-b088-817bb2375732",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Renton Technical College",
      "poi_type": "Education",
      "poi_address": "3000 NE 4th St, Renton, WA 98056, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-e364-73ef-9a3a-752ff3bdbbc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-e364-73ef-9a3a-752ff3bdbbc9",
        "storage_key": "property/6767906449166895/019d08ad-e364-73ef-9a3a-752ff3bdbbc9.webp",
        "width": 1280,
        "height": 382
      },
      "poi_business_url": "http://www.rtc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6638912181410752234&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "renton-technical-college",
      "poi_latitude": "47.4893273",
      "poi_longitude": "-122.175813",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 425-235-2352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8001-7703-8d73-fe364f06562d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8001-7703-8d73-fe364f06562d",
        "storage_key": "property/6767906449166895/019d08ad-8001-7703-8d73-fe364f06562d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkWJAogpokFQR6mYAXHQnIlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_666e4a6b-b042-408a-8913-a7c8a9e3fba4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "The Museum of Flight",
      "poi_type": "Entertainment",
      "poi_address": "Seattle, WA 98108, USA",
      "poi_short_description": "Large educational museum with aircraft & space vehicles on display, plus historical exhibits.",
      "poi_long_description": "People say this museum offers a vast collection of aircraft, including a Boeing 747, Concorde, and Space Shuttle, as well as interactive exhibits and flight simulators. They highlight the museum is family-friendly, educational, and worth the price of admission, especially with a membership. They also like the knowledgeable staff and the opportunity to walk through some of the aircraft.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-e4d7-700a-9c80-c3afa8ab6c23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-e4d7-700a-9c80-c3afa8ab6c23",
        "storage_key": "property/6767906449166895/019d08ad-e4d7-700a-9c80-c3afa8ab6c23.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.museumofflight.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=118380609308048042&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-museum-of-flight",
      "poi_latitude": "47.5185379",
      "poi_longitude": "-122.2968545",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-764-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-85c7-7794-bd9c-8fdb37336acd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-85c7-7794-bd9c-8fdb37336acd",
        "storage_key": "property/6767906449166895/019d08ad-85c7-7794-bd9c-8fdb37336acd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJRxVwIjlCkFQRqroZdomSpAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_4a89c515-e306-47c3-954f-3cdc4070775c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "accesso ShoWare Center",
      "poi_type": "Entertainment",
      "poi_address": "625 W James St, Kent, WA 98032, USA",
      "poi_short_description": "6,500-seat arena that's home to the Seattle Thunderbirds & concerts by nationally known acts.",
      "poi_long_description": "People say this arena offers exciting concerts and hockey games. They also highlight the free parking, quick security lines, and well-maintained facilities.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-e4fc-7197-beda-de49edf5602b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-e4fc-7197-beda-de49edf5602b",
        "storage_key": "property/6767906449166895/019d08ad-e4fc-7197-beda-de49edf5602b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.accessoshowarecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9935684235218299410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "accesso-showare-center",
      "poi_latitude": "47.3870253",
      "poi_longitude": "-122.2398816",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 253-856-6777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8428-749f-ace8-751e06bfef0e",
        "storage_key": "property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJea31XvlbkFQREqqioCuk4ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_5cfe8c10-dedb-4b7d-a809-b23f4bc10f88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Henry Moses Aquatic Center",
      "poi_type": "Entertainment",
      "poi_address": "1719 Maple Vly Hwy, Renton, WA 98057, USA",
      "poi_short_description": "Kids-friendly water park featuring a wave pool, a lazy river and slides and a heated pool.",
      "poi_long_description": "People say this water park offers a wave pool, lazy river, and slides. They also highlight the clean facilities, attentive staff, and fun atmosphere, especially for families with kids.\n\nOther reviews mention the tickets can be pricey.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-e51a-72a5-bfda-f8c371b76258.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-e51a-72a5-bfda-f8c371b76258",
        "storage_key": "property/6767906449166895/019d08ad-e51a-72a5-bfda-f8c371b76258.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rentonwa.gov/Government/Departments-and-Offices/Parks-and-Recreation/Things-To-Do/Henry-Moses-Aquatic-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=313983733861091180&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "henry-moses-aquatic-center",
      "poi_latitude": "47.4817697",
      "poi_longitude": "-122.1949815",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 425-430-6780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8428-749f-ace8-751e06bfef0e",
        "storage_key": "property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq5qPmf5nkFQRbIcK2op-WwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_1c9e9d4a-aa1e-421c-a84e-0334111df8a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Renton Memorial Stadium",
      "poi_type": "Entertainment",
      "poi_address": "405 Logan Ave N, Renton, WA 98057, USA",
      "poi_short_description": "Stadium featuring football games, soccer matches and track meets.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-ed77-77fa-939e-5f2524de9131.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-ed77-77fa-939e-5f2524de9131",
        "storage_key": "property/6767906449166895/019d08ad-ed77-77fa-939e-5f2524de9131.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://rentonhs.rentonschools.us/athletics/renton-memorial-stadium",
      "poi_directions_map_url": "https://maps.google.com/?cid=9465353700824293072&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "renton-memorial-stadium",
      "poi_latitude": "47.4886768",
      "poi_longitude": "-122.2095896",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 425-204-2423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ae-1e6d-72d2-aca4-f00d587c025e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ae-1e6d-72d2-aca4-f00d587c025e",
        "storage_key": "property/6767906449166895/019d08ae-1e6d-72d2-aca4-f00d587c025e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG22ZAqhCkFQR0J4PkwqxW4M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_13e9da55-86b9-43ff-b59b-536518c1f7c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Jimi Hendrix Memorial",
      "poi_type": "Entertainment",
      "poi_address": "350 Monroe Ave NE, Renton, WA 98056, USA",
      "poi_short_description": "Elaborate memorial dedicated to guitarist Jimi Hendrix in the Greenwood Memorial Park cemetery.",
      "poi_long_description": "People say this historical landmark is a beautiful memorial to a legendary guitarist. They highlight the peaceful and contemplative vibe, and the well-maintained cemetery with unique structures. They also like the thoughtful design of the memorial, which incorporates the original headstone and the guitarist's handwritten words.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-ef7e-77bf-bffa-7042c04e8919.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-ef7e-77bf-bffa-7042c04e8919",
        "storage_key": "property/6767906449166895/019d08ad-ef7e-77bf-bffa-7042c04e8919.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.jimihendrixmemorial.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=185179632467479015&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jimi-hendrix-memorial",
      "poi_latitude": "47.4865091",
      "poi_longitude": "-122.1740215",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 425-255-1511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8428-749f-ace8-751e06bfef0e",
        "storage_key": "property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv_jCUeBnkFQR54ncBOXjkQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_0a6bf8e5-c4b3-42b4-b248-1e8a537ea0d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "350 Baker Blvd, Tukwila, WA 98188, USA",
      "poi_short_description": "Chain health club offering cardio and weight equipment, as well as group classes, and a swimming pool.",
      "poi_long_description": "People say this gym offers a variety of machines, a sauna, and strength-building workouts, and the trainers are motivating and knowledgeable.\n\nOther reviews mention the facilities can be poorly maintained and the sauna can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-4491-77b8-80f6-70503f910fd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-4491-77b8-80f6-70503f910fd1",
        "storage_key": "property/6767906449166895/019d08ad-4491-77b8-80f6-70503f910fd1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=533&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=4209536518215593458&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "47.45884040000001",
      "poi_longitude": "-122.2527804",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-331-4071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8428-749f-ace8-751e06bfef0e",
        "storage_key": "property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS4GW1NVckFQR8m1GBSlHazo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6bc50470-c9ab-483b-b947-2c1c8ecbf007",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "20600 108th Ave SE, Kent, WA 98031, USA",
      "poi_short_description": "Fitness chain featuring strength-training equipment, cardio machines, and a pool, plus yoga classes.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including Olympic squat racks, dumbbells, cable machines, cardio equipment, and saunas, and has a friendly and helpful staff.\n\nOther reviews mention the facilities can be poorly maintained and the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-f6a5-70d6-9975-2d33095660d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-f6a5-70d6-9975-2d33095660d3",
        "storage_key": "property/6767906449166895/019d08ad-f6a5-70d6-9975-2d33095660d3.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/kent-wa/panther-lake-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=17830706196700204591&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "47.41731170000001",
      "poi_longitude": "-122.1952027",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 253-220-2342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8428-749f-ace8-751e06bfef0e",
        "storage_key": "property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVRnmjBRdkFQRLw6slNBkc_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cf346754-9816-4e22-8b89-ee0b1498fa2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "18129 E Valley Hwy, Kent, WA 98032, USA",
      "poi_short_description": "Members-only gym chain offering equipment, tanning, and spa services, plus a welcoming, nonjudgmental environment.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment, including machines, tanning beds, and massage machines. They also highlight the friendly, helpful, and welcoming staff, and the clean, spacious, and well-organized facility.\n\nOther reviews mention the temperature can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-ed1b-71bc-9dfc-f125260ed9ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-ed1b-71bc-9dfc-f125260ed9ac",
        "storage_key": "property/6767906449166895/019d08ad-ed1b-71bc-9dfc-f125260ed9ac.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/kent-kent-valley-wa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=16425903657210620319&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "47.4396504",
      "poi_longitude": "-122.2223068",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 253-243-6009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8428-749f-ace8-751e06bfef0e",
        "storage_key": "property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc-HvGNxdkFQRnynUGlmI9OM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ff49492a-b99b-4382-8f0f-db83d57484cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Matt Griffin YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3595 S 188th St, SeaTac, WA 98188, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "Visitors say this gym has a great pool with warm, clean water and excellent swim instructors. They also highlight the spacious layout, solid equipment, and friendly atmosphere.\n\nSome reviews mention the pool can be frequently closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-f972-77f9-b2ef-44b7839a48ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-f972-77f9-b2ef-44b7839a48ff",
        "storage_key": "property/6767906449166895/019d08ad-f972-77f9-b2ef-44b7839a48ff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.seattleymca.org/locations/matt-griffin-ymca?utm_source=google&utm_medium=organic&utm_campaign=business-listing&utm_content=matt-griffin",
      "poi_directions_map_url": "https://maps.google.com/?cid=4772808112517058483&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "matt-griffin-ymca",
      "poi_latitude": "47.4337385",
      "poi_longitude": "-122.2882906",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-244-5880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8428-749f-ace8-751e06bfef0e",
        "storage_key": "property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC5n-BKFckFQRs4-u37BrPEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2ff3b25b-ca15-4b8f-8cd3-7899d24b43a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "17320 Southcenter Pkwy, Tukwila, WA 98188, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-f964-72d5-ac88-9b9cfaac9ec6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-f964-72d5-ac88-9b9cfaac9ec6",
        "storage_key": "property/6767906449166895/019d08ad-f964-72d5-ac88-9b9cfaac9ec6.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tukwila-wa-191",
      "poi_directions_map_url": "https://maps.google.com/?cid=15091536541923712576&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "47.448395",
      "poi_longitude": "-122.2611342",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-575-1444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8428-749f-ace8-751e06bfef0e",
        "storage_key": "property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU5TsiXVdkFQRQJ4wyIbob9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_5be3b248-2d46-48f7-a98f-04095726c541",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Metropolitan Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "6822 S 190th St, Kent, WA 98032, USA",
      "poi_short_description": "Toddler-friendly gymnastics center providing classes and competitive team opportunities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-fd88-7319-b77b-38a7a5a18db9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-fd88-7319-b77b-38a7a5a18db9",
        "storage_key": "property/6767906449166895/019d08ad-fd88-7319-b77b-38a7a5a18db9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://metropolitangym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5093236913196072024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metropolitan-gymnastics",
      "poi_latitude": "47.4328435",
      "poi_longitude": "-122.2477764",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 425-282-5010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8001-7703-8d73-fe364f06562d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8001-7703-8d73-fe364f06562d",
        "storage_key": "property/6767906449166895/019d08ad-8001-7703-8d73-fe364f06562d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnWcqiO1ckFQRWHz1x_zPrkY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_491ba3bf-f767-49f7-9acc-6f297bb2da38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "BluePearl Pet Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "402 Baker Blvd, Tukwila, WA 98188, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-ff56-7442-8058-91516432339d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-ff56-7442-8058-91516432339d",
        "storage_key": "property/6767906449166895/019d08ad-ff56-7442-8058-91516432339d.webp",
        "width": 816,
        "height": 460
      },
      "poi_business_url": "https://bluepearlvet.com/hospital/renton-wa/?utm_source=maps&utm_medium=google&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=16364207143402972431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluepearl-pet-hospital",
      "poi_latitude": "47.458721",
      "poi_longitude": "-122.252096",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 425-496-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8428-749f-ace8-751e06bfef0e",
        "storage_key": "property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcS3WPR1dkFQRD6VxFbJXGeM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_ae501515-9ce0-483d-a3a8-32ae5fb7be80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Valley Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "400 S 43rd St, Renton, WA 98055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-6df7-733b-8ea8-7734c62e0c00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-6df7-733b-8ea8-7734c62e0c00",
        "storage_key": "property/6767906449166895/019d08ad-6df7-733b-8ea8-7734c62e0c00.webp",
        "width": 750,
        "height": 500
      },
      "poi_business_url": "http://www.valleymed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6634061436974118693&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "valley-medical-center",
      "poi_latitude": "47.4428037",
      "poi_longitude": "-122.2138885",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 425-690-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-85c3-7757-a86d-3b3588a37e96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-85c3-7757-a86d-3b3588a37e96",
        "storage_key": "property/6767906449166895/019d08ad-85c3-7757-a86d-3b3588a37e96.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJMS9badNqkFQRJbf1aLrrEFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_cc52101f-b123-4cde-a0c0-b7b447cab331",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "St. Anne Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "16251 Sylvester Rd SW, Burien, WA 98166, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-341a-74fd-a4a0-bfb21a1096ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-341a-74fd-a4a0-bfb21a1096ed",
        "storage_key": "property/6767906449166895/019d08ad-341a-74fd-a4a0-bfb21a1096ed.webp",
        "width": 1209,
        "height": 640
      },
      "poi_business_url": "https://www.vmfh.org/our-hospitals/st-anne-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=10014091768260235562&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "st-anne-hospital",
      "poi_latitude": "47.4573951",
      "poi_longitude": "-122.3425954",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-244-9970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-85c3-7757-a86d-3b3588a37e96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-85c3-7757-a86d-3b3588a37e96",
        "storage_key": "property/6767906449166895/019d08ad-85c3-7757-a86d-3b3588a37e96.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ01Ir55dEkFQRKpFQA2gz-Yo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a6bf385c-a96a-4c67-b8dc-6c09bfad7e44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Gene Coulon Memorial Beach Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1201 Lake Washington Blvd N, Renton, WA 98056, USA",
      "poi_short_description": "Public 57-acre lakeside park offering boat launches, a walking trail, tennis courts & picnic areas.",
      "poi_long_description": "People say this city park offers a variety of activities, including boating, swimming, fishing, and walking trails, as well as a playground, beach, and picnic areas. They highlight the beautiful views of the lake, the well-maintained facilities, and the ample parking. They also like the convenient access to restaurants and the versatile space suitable for families, events, and gatherings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ae-02c1-746b-821a-2234a1af50de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-02c1-746b-821a-2234a1af50de",
        "storage_key": "property/6767906449166895/019d08ae-02c1-746b-821a-2234a1af50de.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rentonwa.gov/Activities-Events/Parks-and-Trails/Gene-Coulon-Memorial-Beach-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17299332345453938081&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gene-coulon-memorial-beach-park",
      "poi_latitude": "47.5068943",
      "poi_longitude": "-122.2020264",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 425-430-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8001-7703-8d74-02e670a15710.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8001-7703-8d74-02e670a15710",
        "storage_key": "property/6767906449166895/019d08ad-8001-7703-8d74-02e670a15710.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk7HarTlokFQRoQU1xhyTE_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_48eb4bd3-257b-469d-a2a8-71ec8621bb62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Kubota Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9817 55th Ave S, Seattle, WA 98118, USA",
      "poi_short_description": "Hilly 20-acre Japanese-style garden dating to 1927, with flowers, ponds, waterfalls & a moon bridge.",
      "poi_long_description": "Visitors say this Japanese garden offers peaceful walking paths, stunning views, and a tranquil atmosphere, perfect for relaxing or enjoying nature. They also highlight the well-maintained grounds, diverse plant life, and abundance of benches for sitting and enjoying the surroundings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ae-037c-70a6-8440-fb31f6fb8eb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-037c-70a6-8440-fb31f6fb8eb6",
        "storage_key": "property/6767906449166895/019d08ae-037c-70a6-8440-fb31f6fb8eb6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kubotagarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16083961869648009774&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kubota-garden",
      "poi_latitude": "47.5134676",
      "poi_longitude": "-122.2658737",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-725-5060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8001-7703-8d74-02e670a15710.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8001-7703-8d74-02e670a15710",
        "storage_key": "property/6767906449166895/019d08ad-8001-7703-8d74-02e670a15710.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA2y97GVCkFQRLhpMnRq2Nd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_fc8ca03f-55b0-444b-abdf-ab6c678b8d3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Saltwater State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "25205 8th Pl S, Des Moines, WA 98198, USA",
      "poi_short_description": "This park on the shores of Puget Sound has campsites, volleyball courts & an artificial reef.",
      "poi_long_description": "People say this state park offers a beautiful beach, hiking trails, and opportunities to explore sea life at low tide. They highlight the peaceful and relaxing vibe, and the availability of amenities such as picnic tables, restrooms, and a playground. They also like the ample parking and the option to bring dogs on leash.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-54f6-74b9-8a3c-d1601664f39c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-54f6-74b9-8a3c-d1601664f39c",
        "storage_key": "property/6767906449166895/019d08ad-54f6-74b9-8a3c-d1601664f39c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://parks.state.wa.us/578/Saltwater",
      "poi_directions_map_url": "https://maps.google.com/?cid=6985291121296586622&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saltwater-state-park",
      "poi_latitude": "47.3758089",
      "poi_longitude": "-122.3231043",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 253-661-4956",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8001-7703-8d74-02e670a15710.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8001-7703-8d74-02e670a15710",
        "storage_key": "property/6767906449166895/019d08ad-8001-7703-8d74-02e670a15710.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ36mzLDlakFQRfreS4UO98GA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_709b58d9-7227-4020-b602-8c02fe0d4c5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Seahurst Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1600 SW Seahurst Park Rd, Burien, WA 98166, USA",
      "poi_short_description": "Scenic Puget Sound beach offering picnicking, forest trails & ample photo opportunities.",
      "poi_long_description": "People say this park offers beautiful forested trails, a restored beach, and stunning views of Puget Sound and the Olympic Mountains. They highlight the peaceful and refreshing vibe, and the family-friendly atmosphere with picnic areas, a playground, and ample open space. They also like the clean facilities, including restrooms and dog waste disposal stations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-5691-75b2-bd27-deaeec94adf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-5691-75b2-bd27-deaeec94adf0",
        "storage_key": "property/6767906449166895/019d08ad-5691-75b2-bd27-deaeec94adf0.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://burienwa.gov/residents/parks_recreation_cultural_services/city_parks_trails_facilities/seahurst_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18197522955814146684&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seahurst-park",
      "poi_latitude": "47.4762175",
      "poi_longitude": "-122.3602348",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 206-988-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8001-7703-8d74-02e670a15710.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8001-7703-8d74-02e670a15710",
        "storage_key": "property/6767906449166895/019d08ad-8001-7703-8d74-02e670a15710.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDbgYQHlEkFQRfJJRtbaWivw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_757206c6-946d-4612-aece-1c9dff713cf5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Angle Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "19408 International Blvd, SeaTac, WA 98188, USA",
      "poi_short_description": "This green space with a lake offers amenities such as a boat launch, playground & water spray park.",
      "poi_long_description": "People say this park offers a lake for swimming, fishing, and boating, as well as a splash pad, playground, and picnic areas. They highlight the beautiful lake views, the ample grassy areas for playing and relaxing, and the availability of lifeguards during the summer. They also like the paved walkways, the easy beach access, and the presence of wildlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-21fa-7698-9224-d12baf3531a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-21fa-7698-9224-d12baf3531a9",
        "storage_key": "property/6767906449166895/019d08ad-21fa-7698-9224-d12baf3531a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seatacwa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10463006071752659881&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "angle-lake-park",
      "poi_latitude": "47.428313",
      "poi_longitude": "-122.294627",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-973-4680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8001-7703-8d74-02e670a15710.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8001-7703-8d74-02e670a15710",
        "storage_key": "property/6767906449166895/019d08ad-8001-7703-8d74-02e670a15710.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJS7NCsWBbkFQRqZOSPZYQNJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_25b4253b-aafd-4993-ac56-ed159bbb2d26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Seattle–Tacoma International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "17801 International Blvd, SeaTac, WA 98158, USA",
      "poi_short_description": "Large hub serving the Pacific Northwest & featuring live music plus rail service to Seattle.",
      "poi_long_description": "Large hub serving the Pacific Northwest & featuring live music plus rail service to Seattle.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-582e-746e-8038-947c586aa568.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-582e-746e-8038-947c586aa568",
        "storage_key": "property/6767906449166895/019d08ad-582e-746e-8038-947c586aa568.webp",
        "width": 1200,
        "height": 798
      },
      "poi_business_url": "https://www.portseattle.org/sea-tac",
      "poi_directions_map_url": "https://maps.google.com/?cid=11084442547078838199&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seattletacoma-international-airport",
      "poi_latitude": "47.4483652",
      "poi_longitude": "-122.3085927",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-787-5388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-898c-75c6-9685-cbbddeacc39f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-898c-75c6-9685-cbbddeacc39f",
        "storage_key": "property/6767906449166895/019d08ad-898c-75c6-9685-cbbddeacc39f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_f7qQlVDkFQRtzfcx8TZ05k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_df2ee316-b25f-46cb-8b19-50ad93b079c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Tukwila Int'l Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "3651 Southcenter Blvd, Tukwila, WA 98188, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-5c9c-772a-bbd0-b3260621c897.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-5c9c-772a-bbd0-b3260621c897",
        "storage_key": "property/6767906449166895/019d08ad-5c9c-772a-bbd0-b3260621c897.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/tukwila-international-boulevard-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=3918699620542677033&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tukwila-intl-blvd",
      "poi_latitude": "47.4640995",
      "poi_longitude": "-122.2882273",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8428-749f-ace8-751e06bfef0e",
        "storage_key": "property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1XkFKzhDkFQRKYDn74oEYjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_7e52f5ec-f7d2-48a5-8603-d8ce14f6dfe9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Tukwila",
      "poi_type": "Transportation & Transit",
      "poi_address": "7301 Longacres Way, Tukwila, WA 98188, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-5db6-73fc-baf7-c25846774340.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-5db6-73fc-baf7-c25846774340",
        "storage_key": "property/6767906449166895/019d08ad-5db6-73fc-baf7-c25846774340.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=TUK",
      "poi_directions_map_url": "https://maps.google.com/?cid=7463838225028263000&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tukwila",
      "poi_latitude": "47.460666",
      "poi_longitude": "-122.2405258",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8ac7-7375-a3f9-f0748943fa70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8ac7-7375-a3f9-f0748943fa70",
        "storage_key": "property/6767906449166895/019d08ad-8ac7-7375-a3f9-f0748943fa70.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJpcZcuC5dkFQRWKzKD1LhlGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_b8fe0ed1-1487-4404-aa14-f35e28531624",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Angle Lake",
      "poi_type": "Transportation & Transit",
      "poi_address": "SeaTac, WA 98198, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ae-0cdc-76ba-9ed5-b0335ca73f66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-0cdc-76ba-9ed5-b0335ca73f66",
        "storage_key": "property/6767906449166895/019d08ae-0cdc-76ba-9ed5-b0335ca73f66.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15554939121471465518&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "angle-lake",
      "poi_latitude": "47.4223163",
      "poi_longitude": "-122.2978013",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8428-749f-ace8-751e06bfef0e",
        "storage_key": "property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUSKHS29bkFQRLigiprc-3tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_0bbdcf69-4235-4b74-b95b-cedbeb484010",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Kent",
      "poi_type": "Transportation & Transit",
      "poi_address": "301 Railroad Ave N, Kent, WA 98032, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ae-0d2a-7110-8a56-0e6abe0f44bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-0d2a-7110-8a56-0e6abe0f44bf",
        "storage_key": "property/6767906449166895/019d08ae-0d2a-7110-8a56-0e6abe0f44bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.soundtransit.org/Rider-Guide/Kent-Station",
      "poi_directions_map_url": "https://maps.google.com/?cid=8298822110823561671&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kent",
      "poi_latitude": "47.3845727",
      "poi_longitude": "-122.2329171",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8ac7-7375-a3f9-f0748943fa70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8ac7-7375-a3f9-f0748943fa70",
        "storage_key": "property/6767906449166895/019d08ad-8ac7-7375-a3f9-f0748943fa70.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJi2fjpP9bkFQRx7nLob1WK3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_90bf1d18-f956-4469-b317-06f82c64b4f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Boeing 10-20",
      "poi_type": "Major Employers & Offices",
      "poi_address": "800 N 6th St, Renton, WA 98057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ae-0d3f-71a2-a6f1-8d73c31d285b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-0d3f-71a2-a6f1-8d73c31d285b",
        "storage_key": "property/6767906449166895/019d08ae-0d3f-71a2-a6f1-8d73c31d285b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8356682190396930037&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "boeing-10-20",
      "poi_latitude": "47.49249",
      "poi_longitude": "-122.204694",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8428-749f-ace8-751e06bfef0e",
        "storage_key": "property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6TDm1DBpkFQR9TdxMy3m-HM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cf3aaf2c-63a0-4b0c-a0b4-c9e42fa002fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "FAA Bldg",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2200 S 216th St, Des Moines, WA 98198, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ae-0dee-71d9-b576-5c55cd110c28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-0dee-71d9-b576-5c55cd110c28",
        "storage_key": "property/6767906449166895/019d08ae-0dee-71d9-b576-5c55cd110c28.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.faa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=523186749664561825&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "faa-bldg",
      "poi_latitude": "47.4093889",
      "poi_longitude": "-122.3054526",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-231-3828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8428-749f-ace8-751e06bfef0e",
        "storage_key": "property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMzNAhgxbkFQRoYryrJO7Qgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_78af7432-3c88-403d-814b-574ae8507b67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Renton City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1055 S Grady Way, Renton, WA 98057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ae-152e-7106-b3d2-74cb628633bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-152e-7106-b3d2-74cb628633bc",
        "storage_key": "property/6767906449166895/019d08ae-152e-7106-b3d2-74cb628633bc.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "http://rentonwa.gov/city_hall",
      "poi_directions_map_url": "https://maps.google.com/?cid=1274733248939844054&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "renton-city-hall",
      "poi_latitude": "47.4747631",
      "poi_longitude": "-122.2047575",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 425-430-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8e46-764f-8591-4472e6040ee7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8e46-764f-8591-4472e6040ee7",
        "storage_key": "property/6767906449166895/019d08ad-8e46-764f-8591-4472e6040ee7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJITiwwVNdkFQR1mFw1iLDsBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_7a5313f7-5549-487b-8dc5-973dc2f14535",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Triton Towers Two",
      "poi_type": "Major Employers & Offices",
      "poi_address": "700 S Renton Village Pl, Renton, WA 98057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ae-1666-71ab-9705-a95daa5c02f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1666-71ab-9705-a95daa5c02f2",
        "storage_key": "property/6767906449166895/019d08ae-1666-71ab-9705-a95daa5c02f2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.tritontowers.com/toc.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=12168192566078800015&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "triton-towers-two",
      "poi_latitude": "47.4701144",
      "poi_longitude": "-122.2089485",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8428-749f-ace8-751e06bfef0e",
        "storage_key": "property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKQ9ZT05dkFQRjwCtQ6sa3qg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_891b890a-cd6f-40ba-a21c-383916bbd3d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "poi_name": "Wizards of the Coast LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1107 Lake Washington Blvd N suite 800, Renton, WA 98056, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ae-1640-71ee-97d0-5da2ddeb9a75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ae-1640-71ee-97d0-5da2ddeb9a75",
        "storage_key": "property/6767906449166895/019d08ae-1640-71ee-97d0-5da2ddeb9a75.webp",
        "width": 1280,
        "height": 575
      },
      "poi_business_url": "http://www.wizards.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1436920051857995426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wizards-of-the-coast-llc",
      "poi_latitude": "47.5025011",
      "poi_longitude": "-122.2045677",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-8428-749f-ace8-751e06bfef0e",
        "storage_key": "property/6767906449166895/019d08ad-8428-749f-ace8-751e06bfef0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ490CvwZvkFQRorahjSz38BM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_c1ea1e1d-d769-451d-9d97-d91ffb8b0ea2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_00c541b1-8649-4ba8-a927-2b99a13b2737",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_b5be0350-a7b6-4b3f-b19c-59d3e4cfbb93",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_63444316-88ac-4ad9-9527-463555682181",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_523108d7-e29a-439d-86a5-296c9ba298b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_73b09879-8c32-48bc-964f-2cdc96f03712",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "day": "SAT",
      "open_time": "14:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_8df32c39-f3e5-46d1-8a8d-e01c8bcc2151",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "rating": "5.0",
      "name": "Ahmed Ali",
      "text": "I lived in this apartment community for 2 years and had a great experience. The neighborhood was quiet, clean, and beautifully green with lots of trees and plants. The management team at the leasing office was always professional and helpful. Maintenance requests were handled quickly, and I always felt safe and comfortable here. They have secure parking and plenty of visitor parking, which was really convenient. I appreciate the time I spent living here and would recommend it to anyone looking for a peaceful, green place to call home.",
      "date": "2025-05-27",
      "title": ""
    },
    {
      "id": "custom_f536902f-5ced-4984-abd2-83e7c2c0d5f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "rating": "5.0",
      "name": "merhawi menghistu",
      "text": "I have lived at hunt Club Apartments since late 2021. Almost stayed in this apartments for close to 4 years. Aneisha the property manager is such an amazing manager. She made sure that her office is open to everyone and she always had a welcoming attitude towards everyone. She is the MVP of all property managers I have encountered in the past. Another amazing fact about hunt club is their top notch maintenance department. If there is any issues, all you got to do is make a request via an app and it will be done the next day. I never felt disappointed. Poa and his team in the maintenance department are wonderful and very professional when they come over to the apartment units to take care of business. The location is also very good. Pretty close to the highway but, also away from traffic making the area quite and conducive to those who like to rest at home during the day. I have had no break ins, never encountered problems safely wise. Another wonderful thing is their Amazon lockbox at the compound. It is such a treat. Your delivery is safe!! I really don’t have anything negative to say about this place except to give a shout out to Aneisha for her amazing job at running the place with humility and top professionalism ❤️❤️❤️",
      "date": "2025-09-18",
      "title": ""
    },
    {
      "id": "custom_70104840-dde7-465b-802a-90d540bb327e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "rating": "5.0",
      "name": "M",
      "text": "I’m a bit behind on my review, but I still wanted to give a big shoutout to Aniesha and her team. When I lived here, they were the real MVPs, making my stay pleasant and enjoyable. They were always respectful and professional, and they made sure to take care of any issues that came up promptly.",
      "date": "2025-08-27",
      "title": ""
    },
    {
      "id": "custom_eba0e0d0-d14c-4310-97cc-e10223ca9231",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "rating": "5.0",
      "name": "Rolando Guadalupe",
      "text": "Hunt Club Apartments is a great place to live and you would be happy here:\n\nPros:\n\n1.\tLocation: Conveniently located near the airport, shopping centers, dining, and major highways. It’s an ideal spot for people who need quick access to work, schools, and leisure activities.\n2.\tAmenities: The complex has amenities such as a fitness center, pool, clubhouse, and grill area. They are pet-friendly too.\n3.\tMaintenance: The maintenance team is responsive, and repairs are generally handled quickly. The grounds are well-kept, with landscaping that adds to the overall aesthetic. Poa is awesome!\n4.  Community: Quiet and family-friendly, it has a welcoming atmosphere that’s safe and comfortable.\n5.   Staff: The property manager Aneisha is amazing to deal with. Always seems to have a positive attitude and great patience. On top of any problem or concern brought to her attention and clearly cares for the tenants!",
      "date": "2024-09-24",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_9dd767e0-843b-4c36-85b0-34fb6784977c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d2c19-42e2-729c-8289-44e99e46584b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c19-42e2-729c-8289-44e99e46584b",
        "storage_key": "property/6767906449166895/019d2c19-42e2-729c-8289-44e99e46584b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Hunt Club Apartments - 1 Bedroom 1 Bath 580 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Fv183fcozVn"
    },
    {
      "id": "custom_2cb18221-a235-4553-9b34-0afb5472f3dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d2c19-680d-7053-81de-cb737b950f47.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c19-680d-7053-81de-cb737b950f47",
        "storage_key": "property/6767906449166895/019d2c19-680d-7053-81de-cb737b950f47.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Hunt Club Apartments - 2 Bedroom 1 Bath 788 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=1EYRtVM7sZF"
    },
    {
      "id": "custom_10383082-ea34-497d-ae24-efe4dc80c02b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d2c19-8067-7724-8bf6-f6bf0b78b928.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c19-8067-7724-8bf6-f6bf0b78b928",
        "storage_key": "property/6767906449166895/019d2c19-8067-7724-8bf6-f6bf0b78b928.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Hunt Club Apartments - 3 Bedroom 2 Bath 1013 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=YnN3MEe9NCC"
    },
    {
      "id": "custom_3850a3c9-b208-4dc0-82ff-6330c1739247",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166895/019d2c19-9dfb-75e3-a56c-e290bd84a715.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2c19-9dfb-75e3-a56c-e290bd84a715",
        "storage_key": "property/6767906449166895/019d2c19-9dfb-75e3-a56c-e290bd84a715.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Hunt Club Apartments - Cabana & Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=SCfWJgXW9FW"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db1a9-411f-706d-9d8a-cf58052bf521",
      "lead_source": "LANDING_PAGE",
      "name": "Hunt Club Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "generator",
      "page_item_url": "hunt-club-apartments-with-pool-seatac-wa",
      "search_query": "apartments with pool in SeaTac WA",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in SeaTac, WA",
      "h2_subtitle": "Discover top-notch apartments with pool access in SeaTac, WA. Enjoy leisure and luxury at Hunt Club, offering amazing amenities.",
      "page_copy": "Nestled in the heart of SeaTac, WA, Hunt Club offers stunning apartments with pool access, designed for those who appreciate both leisure and luxury. Our residents can enjoy a refreshing swim or sunbathe by the pool, perfect for unwinding after a busy day. \n\nBeyond the pool, Hunt Club boasts an array of amenities including a 24-hour package locker system, a well-equipped business center, and a modern fitness facility. There's also a covered BBQ area, ideal for social gatherings with family and friends. Experience exceptional apartment living at Hunt Club where community and convenience come together.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in SeaTac, WA",
      "seo_description": "Discover luxurious apartments with a pool in SeaTac, WA at Hunt Club. Enjoy modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "generator",
      "page_item_url": "hunt-club-in-unit-laundry-apartments-king-county",
      "search_query": "in-unit laundry apartments King County",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments, King County",
      "h2_subtitle": "Experience the convenience of in-unit laundry in King County. Hunt Club offers modern amenities and spacious layouts for everyday comfort.",
      "page_copy": "Hunt Club provides the perfect blend of convenience and comfort with in-unit laundry facilities set in the vibrant community of King County. Our thoughtfully designed apartments mean you can simplify your daily routine while enjoying premium comfort.\n\nLocated in SeaTac, WA, Hunt Club is more than just a home. Offering a wealth of amenities like a fitness facility, swimming pool, and a business center, our community ensures a lifestyle of ease and enjoyment. Take advantage of the covered BBQ area with friends or relax knowing package deliveries are secure with our 24-hour package lockers. Choose Hunt Club and embrace modern living in King County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments, King County",
      "seo_description": "Discover in-unit laundry apartments in King County at Hunt Club. Enjoy modern amenities in a prime SeaTac location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "generator",
      "page_item_url": "hunt-club-fitness-facility-apartments-near-98188",
      "search_query": "fitness facility apartments near 98188",
      "category": "Amenity",
      "h1_title": "Fitness Facility Apartments Near 98188",
      "h2_subtitle": "Located near 98188, Hunt Club offers apartments with a fitness facility. Enhance your lifestyle with our diverse amenities.",
      "page_copy": "For those who value a healthy lifestyle, Hunt Club offers apartments with a state-of-the-art fitness facility, conveniently located near the 98188 area. Our community ensures that staying active is both easy and enjoyable, without having to leave the comfort of your home.\n\nSituated in SeaTac, WA, Hunt Club provides residents more than just a place to live. In addition to our modern fitness facility, residents can benefit from amenities such as a refreshing swimming pool, a convenient business center, and a spacious covered BBQ area. With 24-hour package lockers, Hunt Club makes living simple and stress-free. Choose our apartments and thrive in a community that puts health and convenience first.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Facility Apartments Near 98188",
      "seo_description": "Explore apartments with a fitness facility near 98188 at Hunt Club. Modern amenities and prime location await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "generator",
      "page_item_url": "hunt-club-smoke-free-apartments-seatac",
      "search_query": "smoke free apartments SeaTac",
      "category": "Amenity",
      "h1_title": "Smoke-Free Apartments in SeaTac",
      "h2_subtitle": "Discover smoke-free living at Hunt Club in SeaTac. Enjoy a clean, healthy environment with fantastic amenities.",
      "page_copy": "Hunt Club is proud to offer smoke-free apartments in SeaTac, providing a clean and healthy living environment for our residents. Our commitment to a smoke-free community ensures that everyone can breathe easy and enjoy their surroundings without compromise.\n\nBeyond just being smoke-free, Hunt Club delivers a vibrant lifestyle with amenities such as a modern fitness facility, a refreshing swimming pool, and a business center. Our residents also enjoy a covered BBQ area perfect for socializing and a 24-hour package locker system for seamless delivery management. Experience the perfect blend of convenience and comfort at Hunt Club in the heart of SeaTac.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Apartments in SeaTac",
      "seo_description": "Live in smoke-free apartments in SeaTac at Hunt Club. Enjoy a healthy environment and modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "generator",
      "page_item_url": "hunt-club-flexible-lease-apartments-seatac-wa",
      "search_query": "flexible lease apartments in SeaTac WA",
      "category": "Amenity",
      "h1_title": "Flexible Lease Apartments in SeaTac, WA",
      "h2_subtitle": "Hunt Club in SeaTac, WA, offers flexible lease terms. Enjoy adaptable living with first-class amenities.",
      "page_copy": "At Hunt Club, we understand the need for flexibility in today’s fast-paced world. That’s why we offer flexible lease apartments in SeaTac, WA, allowing you to tailor your living arrangements to suit your lifestyle. Whether you're moving to the area for work or exploring new opportunities, our flexible lease options ensure you have the freedom you need.\n\nSituated in a prime location in SeaTac, Hunt Club provides more than just flexibility. Our residents enjoy top-tier amenities including a state-of-the-art fitness facility, a sparkling swimming pool, and a business center to support any remote working needs. Additional conveniences like a covered BBQ area and 24-hour package lockers exemplify our commitment to a hassle-free living experience. Choose Hunt Club for flexibility, comfort, and community in SeaTac, WA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Flexible Lease Apartments in SeaTac, WA",
      "seo_description": "Discover flexible lease apartments in SeaTac, WA at Hunt Club. Enjoy adaptable living with modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "generator",
      "page_item_url": "hunt-club-one-bedroom-apartments-seatac-wa",
      "search_query": "one bedroom apartments seatac wa",
      "category": "Floorplan",
      "h1_title": "One-Bedroom Apartments in SeaTac, WA",
      "h2_subtitle": "Explore stylish one-bedroom apartments at Hunt Club in SeaTac, WA. Perfectly designed for comfort and convenience.",
      "page_copy": "Discover the perfect one-bedroom apartment at Hunt Club, ideally located in SeaTac, WA. Our thoughtfully designed apartments offer ample space and modern features to ensure your comfort and convenience. Designed to cater to the diverse needs of our residents, these homes provide a cozy retreat with easy access to all the essentials.\n\nIn addition to our inviting one-bedroom apartments, Hunt Club boasts an array of premium amenities. From our state-of-the-art fitness facility and refreshing swimming pool to a productive business center and welcoming covered BBQ area, there are numerous ways to relax and unwind. The inclusion of 24-hour package lockers further enhances the ease of living in our community. Experience stylish and convenient living at Hunt Club in SeaTac, WA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One-Bedroom Apartments in SeaTac, WA",
      "seo_description": "Find comfortable one-bedroom apartments in SeaTac, WA at Hunt Club. Enjoy modern amenities and a prime location in the heart of the city.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "generator",
      "page_item_url": "hunt-club-two-bedroom-apartments-near-king-county",
      "search_query": "two bedroom apartments near king county",
      "category": "Floorplan",
      "h1_title": "Two-Bedroom Apartments Near King County",
      "h2_subtitle": "Check out spacious two-bedroom apartments near King County at Hunt Club. Perfect for comfort and style.",
      "page_copy": "If you're searching for spacious two-bedroom apartments near King County, Hunt Club in SeaTac is the perfect place. Our two-bedroom apartments offer expansive living spaces designed for modern comfort and functionality. Ideal for families or roommates, these residences combine style with practicality, ensuring a delightful living experience.\n\nLocated in the vibrant area of SeaTac, Hunt Club not only offers fantastic living options but also premium amenities. Enjoy access to our fully-equipped fitness facility, unwind by the swimming pool, or get work done in our business center. The community also features a covered BBQ area for social gatherings and 24-hour package lockers for added convenience. Experience the perfect blend of comfort and community at Hunt Club, just a short distance from King County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two-Bedroom Apartments Near King County",
      "seo_description": "Discover two-bedroom apartments near King County at Hunt Club. Enjoy spacious living and excellent amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166895",
      "source": "generator",
      "page_item_url": "hunt-club-three-bedroom-apartments-in-98188",
      "search_query": "three bedroom apartments in 98188",
      "category": "Floorplan",
      "h1_title": "Three-Bedroom Apartments in 98188",
      "h2_subtitle": "Discover expansive three-bedroom apartments in the 98188 area at Hunt Club. Ideal for larger households seeking space and convenience.",
      "page_copy": "Come home to Hunt Club, where our three-bedroom apartments in the 98188 area offer plenty of space for families and roommates alike. These homes are crafted to provide a perfect balance of privacy and communal living, ensuring each occupant can enjoy their own personal space while gathering in expansive common areas.\n\nLocated in SeaTac, Hunt Club delivers more than just spacious apartments. Our amenities are designed to enhance your lifestyle—whether you’re kicking back by the swimming pool, breaking a sweat in the fitness center, or taking advantage of the business center for work-from-home convenience. With additional perks like a covered BBQ area and round-the-clock package lockers, Hunt Club makes life in the 98188 area both pleasant and practical.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three-Bedroom Apartments in 98188",
      "seo_description": "Explore three-bedroom apartments in the 98188 area at Hunt Club. Enjoy spacious living with outstanding amenities in SeaTac, WA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "brianna@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5948"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372411888"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P4R44JSW"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-348-1703 "
    }
  ],
  "custom_csm": "brianna@repli360.com",
  "custom_qb_id": "5948",
  "custom_repli_id": "18372411888",
  "custom_google_gtm_id": "GTM-P4R44JSW",
  "custom_ads_subscription": "essential",
  "custom_seo_subscription": "none",
  "custom_social_subscription": "none",
  "custom_website_subscription": "none",
  "custom_ppc_tracking_phone_number": "844-348-1703 "
};

export const generatedAt = '2026-10-22T17:28:03.464Z';
